import axios, {AxiosResponse} from 'axios'
import {SERVER_URL} from '../../../../ServerConfig'

const API_URL = SERVER_URL
const BANNER_URL = `${API_URL}/banner`
const UPLOAD_MEDIA_URL = `${API_URL}/uploads/upload`
const DOWNLOAD_MEDIA_URL = `${API_URL}/downloads/download?folder_name=banners&image=`

// Field name decides the upload folder on the server (uploads/banners)
export const BANNER_UPLOAD_FIELD = 'banners'

export type Banner = {
  index: number
  image: string
  image_url: string
  redirect_url: string | null
  // true when the API fell back to the default banner for this index
  is_default?: boolean
}

const getBanners = (): Promise<any> => {
  return axios.get(BANNER_URL).then((response: AxiosResponse<any>) => response.data)
}

const saveBanner = (index: number, data: {image_name: string; redirect_url: string}): Promise<any> => {
  return axios
    .put(`${BANNER_URL}/${index}`, data)
    .then((response: AxiosResponse<any>) => response.data)
}

const deleteBanner = (index: number): Promise<any> => {
  return axios.delete(`${BANNER_URL}/${index}`).then((response: AxiosResponse<any>) => response.data)
}

const uploadBannerImage = (file: File): Promise<any> => {
  const formData = new FormData()
  formData.append(BANNER_UPLOAD_FIELD, file)
  return axios.post(UPLOAD_MEDIA_URL, formData).then((response: AxiosResponse<any>) => response.data)
}

const bannerImageUrl = (imageName: string) => `${DOWNLOAD_MEDIA_URL}${encodeURIComponent(imageName)}`

export {getBanners, saveBanner, deleteBanner, uploadBannerImage, bannerImageUrl}
